export const STATUS_ALL = 'all';
export const STATUS_NONE = 'none';
export const STATUS_PARTIAL = 'partial';
